import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { Section } from '../../../Section';
import { ArticleCard } from '../../ArticleCard';
import { getLink } from '../utils';
import { MainColumn, Three } from '../partials';
var FEATURED_ARTICLES_QTY = 3;
var BTopicSection = function BTopicSection(_ref) {
  var tag = _ref.tag,
    _ref$articlesQty = _ref.articlesQty,
    articlesQty = _ref$articlesQty === void 0 ? 8 : _ref$articlesQty,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? true : _ref$withTitle;
  var theme = useTheme();
  var articlesInput = tag.articles;
  var articles = articlesInput.filter(function (_ref2) {
    var title = _ref2.title;
    return title.length < 100;
  });
  var articlesWithImage = articles.filter(function (_ref3) {
    var image = _ref3.image;
    return Boolean(image);
  });
  var featuredArticle = articlesWithImage.slice(0, FEATURED_ARTICLES_QTY);
  var otherArticle = articles.filter(function (item) {
    return !featuredArticle.map(function (_ref4) {
      var id = _ref4.id;
      return id;
    }).includes(item.id);
  }).slice(0, articlesQty - FEATURED_ARTICLES_QTY);
  var isStorefront = !tag.tag.hasOwnProperty('window') || tag.tag.window;
  var link = getLink(theme, tag.tag);
  var title = isStorefront ? tag.tag.name : "\xDAltimos contenidos de ".concat(tag.tag.name);
  return React.createElement(Section, {
    bottomMargin: bottomMargin,
    title: withTitle ? title : null,
    link: withTitle ? link : undefined
  }, React.createElement(MainColumn, null, React.createElement(Three, null, featuredArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "medium",
      article: article,
      withImage: true,
      withDate: false,
      withAuthor: false
    });
  }))), React.createElement("div", null, React.createElement(MainColumn, null, React.createElement(Three, null, otherArticle.map(function (article, index) {
    return React.createElement(ArticleCard, {
      key: index,
      variant: "small",
      article: article,
      withImage: true,
      withAuthor: false,
      withDate: false
    });
  })))));
};
export default BTopicSection;